import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";

export const CtaBanner = ({
  title,
  text,
  primaryLabel,
  primaryTo,
  secondaryLabel,
  secondaryHref,
  idPrefix,
}) => (
  <Reveal>
    <div
      data-testid={`${idPrefix}-cta-banner`}
      className="dot-bg relative overflow-hidden rounded-[2.5rem] bg-brand-dark px-6 py-14 text-center sm:px-12"
    >
      <div
        className="pointer-events-none absolute -left-20 -top-20 h-56 w-56 rounded-full bg-brand/60"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-24 -right-16 h-64 w-64 rounded-full bg-brand-green/30"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-2xl">
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          {title}
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">{text}</p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to={primaryTo}
            data-testid={`${idPrefix}-cta-primary`}
            className="inline-flex min-h-[48px] w-full items-center justify-center gap-2 rounded-full bg-brand-amber px-7 py-3 text-[15px] font-bold text-brand-ink transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-amber-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white sm:w-auto"
          >
            {primaryLabel}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          {secondaryHref && (
            <a
              href={secondaryHref}
              data-testid={`${idPrefix}-cta-secondary`}
              className="inline-flex min-h-[48px] w-full items-center justify-center gap-2 rounded-full border border-white/40 px-7 py-3 text-[15px] font-semibold text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white sm:w-auto"
            >
              <Phone className="h-4 w-4" aria-hidden="true" />
              {secondaryLabel}
            </a>
          )}
        </div>
      </div>
    </div>
  </Reveal>
);
